// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.page-title {
  font-size: 1.5em;
  font-weight: bold;
}
.page-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.page-form {
  display: flex;
  flex-direction: column;
}
.page-form-layout {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2em;
}
.page-document-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.page-document-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.page-content-field {
  flex: 1 1;
  align-self: flex-start;
  margin: 1em;
}
.page-document-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: center;
  margin-left: 1em;
  flex: 1 1;
}
.page-document-area {
  min-height: 10.7em !important;
  max-height: 10.7em !important;
  margin-bottom: 1em;
  flex: 1 1;
}
.page-document-area:active, .page-document-area:focus {
  box-shadow: none;
  border-color: #8f003c;
}
.page-document-action {
  margin-block: 1.5em;
  margin-left: auto;
}

.page-option-label {
  margin-right: 0.5em;
}

.page-document-array {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.page-document-delete-button {
  cursor: pointer;
  margin-top: 0.5em;
}

.page-document {
  width: 100%;
  border-top: 1px solid #e2e5e7;
}`, "",{"version":3,"sources":["webpack://./src/components/views/pages/pageForm/pageForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,gBAAA;EACA,iBAAA;AAAF;AAGC;EACC,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBEjBM;AFgBR;AAIC;EACC,aAAA;EACA,sBAAA;AAFF;AAIE;EC3BD,aAAA;EACA,6BD2BgB;EC1BhB,uBD0B8B;EAC5B,eAAA;EACA,QAAA;AAAH;AAIC;EACC,aAAA;EACA,8BAAA;EACA,eAAA;AAFF;AAKC;EClCA,aAAA;EACA,sBAAA;EACA,2BDiCqB;EChCrB,uBDgCiC;EAChC,WAAA;AAAF;AAGC;EACC,SAAA;EACA,sBAAA;EACA,WAAA;AADF;AAIC;EC7CA,aAAA;EACA,sBAAA;EACA,uBD4CqB;EC3CrB,uBD2C6B;EAC5B,kBAAA;EACA,gBAAA;EACA,SAAA;AACF;AAEC;EACC,6BAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;AAAF;AAEE;EAEC,gBAAA;EACA,qBEpEQ;AFmEX;AAKC;EACC,mBAAA;EACA,iBAAA;AAHF;;AAQC;EACC,mBAAA;AALF;;AASA;EACC,WAAA;EC9EA,aAAA;EACA,sBAAA;EACA,uBD6EoB;EC5EpB,mBD4E4B;AAH7B;;AAMA;EACC,eAAA;EACA,iBAAA;AAHD;;AAMA;EACC,WAAA;EACA,6BAAA;AAHD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.page {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t&-title {\n\t\tfont-size: 1.5em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-top: 2em;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t}\n\n\t&-form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&-layout {\n\t\t\t@include flex(space-evenly, flex-start);\n\t\t\tflex-wrap: wrap;\n\t\t\tgap: 2em;\n\t\t}\n\t}\n\n\t&-document-content{\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-wrap: wrap;\n\t}\n\n\t&-document-container{\n\t\t@include flexColumn(flex-start, flex-start);\n\t\twidth: 100%;\n\t}\n\n\t&-content-field {\n\t\tflex: 1;\n\t\talign-self: flex-start;\n\t\tmargin: 1em;\n\t}\n\n\t&-document-group {\n\t\t@include flexColumn(center, flex-start);\n\t\talign-self: center;\n\t\tmargin-left: 1em;\n\t\tflex: 1;\n\t}\n\n\t&-document-area {\n\t\tmin-height: 10.7em !important;\n\t\tmax-height: 10.7em !important;\n\t\tmargin-bottom: 1em;\n\t\tflex: 1;\n\n\t\t&:active,\n\t\t&:focus {\n\t\t\tbox-shadow: none;\n\t\t\tborder-color: $dark-red;\n\t\t}\n\t}\n\n\t&-document-action {\n\t\tmargin-block: 1.5em;\n\t\tmargin-left: auto;\n\t}\n}\n\n.page-option {\n\t&-label {\n\t\tmargin-right: .5em;\n\t}\n}\n\n.page-document-array{\n\twidth: 100%;\n\t@include flexColumn(center, center)\n}\n\n.page-document-delete-button{\n\tcursor: pointer;\n\tmargin-top: .5em\n}\n\n.page-document {\n\twidth: 100%;\n\tborder-top: 1px solid $grey2;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
